module.exports = __webpack_public_path__ + "img/subject_01.jpg";